#import "./SentenceRecordingDetails.graphql"
query MySentenceRecordingsQuery($sentences: [ID!]) {
  mySentenceRecordings(sentences: $sentences) {
    ...sentenceRecordingDetails
  }
}
